var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview fixed overlay bg-black text-white flex items-center justify-center"},[_vm._v("Loading Preview...")])}
var staticRenderFns = []

export { render, staticRenderFns }